import React from 'react';
import Icon from '../../../components/AppIcon';


const ProjectFilters = ({ 
  statusFilter, 
  onStatusFilterChange, 
  sortBy, 
  onSortChange,
  viewMode,
  onViewModeChange 
}) => {
  const statusOptions = [
    { value: 'all', label: 'All Projects', icon: 'List' },
    { value: 'on-track', label: 'On Track', icon: 'CheckCircle2' },
    { value: 'due-soon', label: 'Due Soon', icon: 'Clock' },
    { value: 'overdue', label: 'Overdue', icon: 'AlertCircle' }
  ];

  const sortOptions = [
    { value: 'delivery-date', label: 'Delivery Date', icon: 'Calendar' },
    { value: 'client-name', label: 'Client Name', icon: 'User' },
    { value: 'project-value', label: 'Project Value', icon: 'DollarSign' }
  ];

  const viewModes = [
    { value: 'weekly', label: 'Weekly', icon: 'CalendarDays' },
    { value: 'monthly', label: 'Monthly', icon: 'Calendar' },
    { value: 'quarterly', label: 'Quarterly', icon: 'CalendarRange' }
  ];

  return (
    <div className="bg-white rounded-xl shadow-elevation-2 p-4 md:p-6 mb-4 md:mb-6">
      <div className="flex flex-col lg:flex-row lg:items-center gap-4 md:gap-6">
        <div className="flex-1">
          <label className="text-sm font-medium text-foreground mb-2 block">
            Filter by Status
          </label>
          <div className="flex flex-wrap gap-2">
            {statusOptions?.map((option) => (
              <button
                key={option?.value}
                onClick={() => onStatusFilterChange(option?.value)}
                className={`px-3 md:px-4 py-2 rounded-lg text-sm font-medium transition-smooth flex items-center gap-2 ${
                  statusFilter === option?.value
                    ? 'bg-primary text-primary-foreground'
                    : 'bg-muted text-muted-foreground hover:bg-muted/80'
                }`}
              >
                <Icon name={option?.icon} size={16} />
                <span className="hidden sm:inline">{option?.label}</span>
              </button>
            ))}
          </div>
        </div>

        <div className="flex-1">
          <label className="text-sm font-medium text-foreground mb-2 block">
            Sort by
          </label>
          <div className="flex flex-wrap gap-2">
            {sortOptions?.map((option) => (
              <button
                key={option?.value}
                onClick={() => onSortChange(option?.value)}
                className={`px-3 md:px-4 py-2 rounded-lg text-sm font-medium transition-smooth flex items-center gap-2 ${
                  sortBy === option?.value
                    ? 'bg-secondary text-secondary-foreground'
                    : 'bg-muted text-muted-foreground hover:bg-muted/80'
                }`}
              >
                <Icon name={option?.icon} size={16} />
                <span className="hidden sm:inline">{option?.label}</span>
              </button>
            ))}
          </div>
        </div>

        <div className="flex-1">
          <label className="text-sm font-medium text-foreground mb-2 block">
            View Mode
          </label>
          <div className="flex flex-wrap gap-2">
            {viewModes?.map((mode) => (
              <button
                key={mode?.value}
                onClick={() => onViewModeChange(mode?.value)}
                className={`px-3 md:px-4 py-2 rounded-lg text-sm font-medium transition-smooth flex items-center gap-2 ${
                  viewMode === mode?.value
                    ? 'bg-accent text-accent-foreground'
                    : 'bg-muted text-muted-foreground hover:bg-muted/80'
                }`}
              >
                <Icon name={mode?.icon} size={16} />
                <span>{mode?.label}</span>
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectFilters;